<!-- <p>gamerecord-list-item-disabled works!</p> -->
<div class="gr-container mb-2 disabled py-2" matRipple [style.backgroundColor]="backgroundColor">
    <div class="gr-icon">
        <div [hidden]="!data.iconName" style="align-self: center;">
            <img [src]="'assets/icons/'+data.iconName+'.svg'" alt="">
        </div>
    </div>
    <!-- icon am Anfang -->
    <table class="gr-info">
        <tr>
            <td>{{data.data.wildart}}</td>
            <td class="txt-end">{{data.data.timeStamp | date:'short':undefined:locale}}</td>
        </tr>
        <tr>
            <!-- <td>{{data.data.htmlErleger()}}</td> -->
           <td></td>
            <td class="txt-end">{{data.data.status}}</td>
        </tr>
        <tr *ngIf="data.data.tagid != undefined">
            <td>{{data.data.tagid}}</td>
            <td class="txt-end">{{data.data.currentLocationID}}</td>
        </tr>
        <tr>
            <td>{{data.data.htmlBottomString()}}</td>
            <td class="txt-end" [hidden]="data.data.tagid != undefined">{{data.data.currentLocationID}}</td>
        </tr>
        
        <tr *ngIf="data.data?.laboratorySamples">
            <td >
                <div class=" d-flex flex-wrap py-1">
                    <span *ngFor="let lab of data.data?.laboratorySamples" class="p-1 rounded-pill mr-1" [style.background-color]="getLabColor(lab)" style="font-size: 10px;line-height: 2;">{{lab?.type}}</span>
                </div>
            </td>
        </tr>
    </table>
    <!-- icon am Ende -->
    <div class="gr-icon">
        <!-- <button mat-icon-button >
            <mat-icon>keyboard_arrow_right</mat-icon>
        </button> -->
    </div>
</div>
